import Reveal from "./ui/Reveal";

const RESENAS = [
  {
    nombre: "Camila Rojas",
    ciudad: "Viña del Mar",
    estrellas: 5,
    texto:
      "La mejor mantequilla de maní que he probado. Se nota que es natural, sin ese dulzor artificial. La uso en mis tostadas todos los días.",
  },
  {
    nombre: "Matías Fuentes",
    ciudad: "Valparaíso",
    estrellas: 5,
    texto:
      "Como deportista busco proteína natural y esta es perfecta. Textura cremosa y un sabor a maní increíble. ¡Recomendada al 100%!",
  },
  {
    nombre: "Daniela Soto",
    ciudad: "Quilpué",
    estrellas: 5,
    texto:
      "Me encanta que tenga un solo ingrediente. Es justo lo que buscaba para mis hijos, sin azúcar ni conservantes. La entrega fue súper rápida.",
  },
  {
    nombre: "Felipe Araya",
    ciudad: "Concón",
    estrellas: 5,
    texto:
      "Compré un frasco para probar y ahora pido todos los meses. La atención por WhatsApp es excelente y el producto de primera.",
  },
];

// Genera la fila de estrellas en color honey gold.
const Estrellas = ({ cantidad }) => (
  <div className="flex gap-1 text-lg" aria-label={`${cantidad} de 5 estrellas`}>
    {Array.from({ length: 5 }, (_, indice) => (
      <span
        key={indice}
        className={indice < cantidad ? "text-gold" : "text-white/20"}
        aria-hidden="true"
      >
        ★
      </span>
    ))}
  </div>
);

const Testimonios = () => {
  return (
    <section id="testimonios" className="bg-charcoal py-20 text-white md:py-section">
      <div className="mx-auto max-w-container px-5 md:px-16">
        <Reveal className="mx-auto max-w-3xl text-center">
          <span className="text-xs font-semibold uppercase tracking-label text-gold">
            Reseñas de clientes
          </span>
          <h2 className="mt-3 font-literata text-2xl font-bold text-white sm:text-3xl md:text-4xl">
            Lo que dicen quienes ya la probaron
          </h2>
          <p className="mt-4 text-base text-white/70 sm:text-lg">
            Cientos de frascos entregados y un montón de clientes felices en toda
            la región.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:mt-16 sm:grid-cols-2 sm:gap-6">
          {RESENAS.map((resena, indice) => (
            <Reveal
              as="li"
              key={resena.nombre}
              delay={indice * 80}
              className="relative overflow-hidden rounded-xl border border-white/10 border-t-2 border-t-gold/40 bg-white/[0.07] p-7 transition-colors duration-300 hover:bg-white/[0.1] sm:p-8"
            >
              {/* Comilla decorativa de fondo */}
              <span
                className="pointer-events-none absolute -right-2 -top-6 font-literata text-9xl leading-none text-gold/10"
                aria-hidden="true"
              >
                ”
              </span>
              <Estrellas cantidad={resena.estrellas} />
              <blockquote className="relative mt-5 text-lg leading-relaxed text-white/90">
                “{resena.texto}”
              </blockquote>
              <footer className="mt-6">
                <p className="font-literata text-lg font-semibold text-white">
                  {resena.nombre}
                </p>
                <p className="text-sm text-white/60">{resena.ciudad}</p>
              </footer>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Testimonios;
